import { IRisks } from "../../interface";

export interface IListAnalysis {
    riskData: IRisks;
    onCallback?: () => void;
}

export enum TypeBadge {
    IMPACT = 1,
    PROBABILITY = 2,
    QUADRANT = 3,
    SITUATION = 4
}
